// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__ze-Ba","footer_dark":"footer_footer_dark__nXEYY","MiniLogo":"footer_MiniLogo__MH1n1"};